module.exports = __webpack_public_path__ + "img/check-report-button.3e1780ba.png";